const state = {
  isShowDebug: true,
  renderInfo: {},
  viewerConfig:  {},
  statsDom: {},
  timeText: '',
  fps: 0,
  minFps: 10000,
  maxFps: 0,
}

let fpsArray = [];

const mutations = {
  show(state) {
    state.isShowDebug = true
  },
  hide(state) {
    state.isShowDebug = false
  },
  updateRenderInfo(state, info){
    state.renderInfo = info;
  },
  updateConfig(state, config){
    state.viewerConfig = config
  },
  updateTime(state, text){
    state.timeText = text;
  },
  updateFps(state, fps){
    fpsArray.push(fps);
    if(fpsArray.length > 10){
      fpsArray.shift();
    }
    const averagedFps = fpsArray.reduce((a,x)=> a+=x, 0)/fpsArray.length || 0;
    state.fps = averagedFps.toFixed(1);

    if(averagedFps < state.minFps && averagedFps != 0){
      state.minFps = averagedFps.toFixed(1);
    }

    if(averagedFps > state.maxFps){
      state.maxFps = averagedFps.toFixed(1);
    }
  }
}

const getters = {
  menuNames: (state)=>{
    const config = state.viewerConfig;
    if(!config.views)
      return [];
    const keys = Object.keys(config.views);
    const namedArray = keys.map((v)=>{
      switch(v){
        case 'exterior':
          return "外観";
        case 'floor1':
          return "1F";
        case 'floor2':
          return "2F";
        case 'floor3':
          return "3F";
        default:
          return v;
      }
    });
    return namedArray;
  },
  viewList: (state)=>{
    const config = state.viewerConfig;
    if(!config.views)
      return [];
    const keys = Object.keys(config.views);
    return keys;
  }
  
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
